import { addCollection, Icon } from '@iconify/vue'

import { definePlugin } from '/@/app'
// Import our custom icons
import customIcons from '/@/assets/icons/icons.json'

export default definePlugin(({ app }) => {
  app.component('IconifyIcon', Icon)
  addCollection(customIcons)
})
